import { IMAGES } from "@/config";
import { COMMON_TOKEN_IDS, PENDLE_PT_LOCK_TOKEN_IDS } from "@/types";

const FALLBACK_ASSET_KEY = "_FALLBACK";

export const ASSET_URLS = {
    [FALLBACK_ASSET_KEY]: IMAGES.TOKEN_FALLBACK,
    INFINIFI: IMAGES.INFINIFI_LOGO,
    INFINIFI_DARK: IMAGES.INFINIFI_DARK_LOGO,
    INFINIFI_X: IMAGES.INFINIFI_X_LOGO,
    INFINIFI_CIRC: IMAGES.INFINIFI_CIRC_LOGO,
    PENDLE: IMAGES.PENDLE_LOGO,
    CURVE: IMAGES.CURVE_LOGO,
    BALANCER: IMAGES.BALANCER_LOGO,
    ETHENA: IMAGES.ETHENA_LOGO,
    STRATA: IMAGES.STRATA_LOGO,
    SILO: IMAGES.SILO_LOGO,
    TAU: IMAGES.TAU_LOGO,
    MORPHO: IMAGES.MORPHO_LOGO,
    FLUID: IMAGES.FLUID_LOGO,
    SEAMLESS: IMAGES.SEAMLESS_LOGO,
    ODYSSEY: IMAGES.ODYSSEY_LOGO,
    GEARBOX: IMAGES.GEARBOX_LOGO,
    NEXUS_MUTUAL: IMAGES.NEXUS_MUTUAL_LOGO,
    ETHEREUM: IMAGES.ETHEREUM,
    KATANA: IMAGES.KATANA,
    ARBITRUM: IMAGES.ARBITRUM,
    [COMMON_TOKEN_IDS.USDC]: IMAGES.TOKEN_USDC,
    [COMMON_TOKEN_IDS.IUSD]: IMAGES.TOKEN_IUSD,
    [COMMON_TOKEN_IDS.SIUSD]: IMAGES.TOKEN_SIUSD,
    [COMMON_TOKEN_IDS.LIUSD]: IMAGES.TOKEN_LIUSD,
    [COMMON_TOKEN_IDS.USDT]: IMAGES.TOKEN_TETHER,
    [COMMON_TOKEN_IDS.SUSDE]: IMAGES.TOKEN_SUSDE,
    [COMMON_TOKEN_IDS.USDE]: IMAGES.TOKEN_USDE,
    [PENDLE_PT_LOCK_TOKEN_IDS.PT_SLVLUSD_25SEP2025]: IMAGES.TOKEN_SLVLUSD,
    [PENDLE_PT_LOCK_TOKEN_IDS.PT_SUSDE_25SEP2025]: IMAGES.TOKEN_SUSDE,
    [PENDLE_PT_LOCK_TOKEN_IDS.PT_USDE_25SEP2025]: IMAGES.TOKEN_USDE,
    [PENDLE_PT_LOCK_TOKEN_IDS.PT_USR_4SEP2025]: IMAGES.TOKEN_USR,
    [PENDLE_PT_LOCK_TOKEN_IDS.PT_WSTUSR_25SEP2025]: IMAGES.TOKEN_USR,
    [PENDLE_PT_LOCK_TOKEN_IDS.PT_TUSDE_25SEP2025]: IMAGES.TOKEN_TUSDE,
    [PENDLE_PT_LOCK_TOKEN_IDS.PT_PUSDE_16OCT2025]: IMAGES.TOKEN_PUSDE,
    [PENDLE_PT_LOCK_TOKEN_IDS.PT_SUSDE_27NOV2025]: IMAGES.TOKEN_SUSDE,
    [PENDLE_PT_LOCK_TOKEN_IDS.PT_USDE_27NOV2025]: IMAGES.TOKEN_USDE,
    [PENDLE_PT_LOCK_TOKEN_IDS.PT_TUSDE_18DEC2025]: IMAGES.TOKEN_TUSDE,
    [PENDLE_PT_LOCK_TOKEN_IDS.PT_SYRUPUSDC_30OCT2025]: IMAGES.TOKEN_SYRUPUSDC,
    [PENDLE_PT_LOCK_TOKEN_IDS.PT_WSRUSD_30OCT2025]: IMAGES.TOKEN_WSRUSD,
} as const;

export type AssetImageKey = keyof typeof ASSET_URLS;

const isAssetImageKey = (name: string): name is AssetImageKey => {
    return name in ASSET_URLS;
};

export const safeAssetIconName = (name: string): AssetImageKey => {
    return isAssetImageKey(name) ? name : FALLBACK_ASSET_KEY;
};
